module.exports = __webpack_public_path__ + "static/media/4.00133eb6.png";